import Vue from "vue";
import VueX from "vuex";
import app from "./module/app";
// import movies from './module/movies';
import users from "./module/users";
import client from "./module/client";
import vehicleBooking from "./module/vehicleBooking";
import vehicleArray from "./module/vehicleSelectedData";
import assign from "./module/assignmentOrder";
import containerValid from "./module/containerValid";
import common from "./module/common";
import commonDropdownMaster from "./module/commonDropdownMaster";
import enqPriceEngineDropdown from "./module/enqPriceEngineDropdown";

Vue.use(VueX);

export default new VueX.Store({
  modules: {
    app,
    // movies,
    users,
    client,
    vehicleBooking,
    vehicleArray,
    assign,
    containerValid,
    common,
    commonDropdownMaster,
    enqPriceEngineDropdown,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js